import React from 'react';
import { Grid } from '@mui/material';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { setSelectedSourceKey } from './store/cluster-summary-slice';
import ClusterSummaryTopBar from './cluster-summary-top-bar';

export default function ClusterSummaryToggleButtons() {
    const appDispatch = useAppDispatch();
    const {selectedSourceKey,
         clusterSummaryTableData
    } = useAppSelector((state) => state.clusterSummary);

    return (
        <>
        
        <Grid item xs={12} sx={{ textAlign: 'left' }}>
            <Grid container spacing={1} alignItems='center' >
                <Grid item>
                    <h4>Add Scenario For Cluster Summary</h4>
                </Grid>
            
            </Grid>
        </Grid>
        <Grid container justifyContent="space-between" alignItems="center" sx={{mt:2}}>
            <ToggleButtonGroup
                size="small"
                color="primary"
                value={selectedSourceKey}
                exclusive
                onChange={(_, value) => {
                    if (value) {
                        appDispatch(setSelectedSourceKey(value));
                    }
                }}
            >
                {clusterSummaryTableData.row?.map(({ parent }) => (
                    <ToggleButton 
                        key={parent.source_id} 
                        value={parent.source_id} 
                        aria-label={parent.alias}
                        sx={{
                            fontSize: '14px',
                            padding: '5px', 
                            minWidth: '60px',
                            justifyContent: 'center',
                        }}>
                        {parent.country}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
            <Grid item xs = {6} >
            <ClusterSummaryTopBar />
          </Grid>
        </Grid>
        </>
    );
}